export const INTENTS = ["bill", "save"] as const;

export type Intent = (typeof INTENTS)[number];

export const isIntent = (value: string): value is Intent =>
  (INTENTS as readonly string[]).includes(value);

export type IntentData = { intent: Intent };

/**
 * Callers must pass `intent: undefined` explicitly, so a missing intent reads
 * as a deliberate signal rather than an omission.
 */
export type ResolvedIntentData = { intent: Intent | undefined };

export type HouseholdData = { householdSize: number };

/**
 * Partner binding as the resume read established it: `null` means a
 * successful read said the user has no partner. An unresolved read never
 * enters the flow (the shell holds entry behind a try-again screen), so the
 * binding is always a known fact here.
 */
export type OnboardingPartner = {
  name: string;
  slug: string;
};

export type PartnerData = { partner: OnboardingPartner | null };

/**
 * Distinct from having an intent: two pre-signup paths record an intent
 * without ever showing a pitch.
 */
export type RoutingPitchData = { sawRoutingPitch: boolean };

export type CarrierData = { carrier: string };

/** A payer picked from the catalog, not yet recorded. */
export type PickedPayerData = { carrier: string; payerId: string };

/**
 * Subscriber identity as the profile step captured it. ISO `YYYY-MM-DD` for
 * the DOB — the eligibility 270 parses only that shape.
 */
export type OnboardingIdentity = {
  firstName: string;
  lastName: string;
  dateOfBirth: string;
};

export type IdentityData = { identity?: OnboardingIdentity };
